var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanceApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.5536 130.703C127.967 130.703 159.107 103.548 159.107 70.0495C159.107 36.5514 127.967 9.39581 89.5536 9.39581C51.1402 9.39581 20 36.5514 20 70.0495C20 103.548 51.1402 130.703 89.5536 130.703Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.968 120.359H116.209V129.519H150.968V120.359Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M143.371 111.402H108.611V120.562H143.371V111.402Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.005 6H60.1875V129.519H129.005V6Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.845 20.0823H65.8828V107.008H122.845V20.0823Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M94.8022 124.881C98.5211 124.881 101.536 121.864 101.536 118.142C101.536 114.42 98.5211 111.402 94.8022 111.402C91.0832 111.402 88.0684 114.42 88.0684 118.142C88.0684 121.864 91.0832 124.881 94.8022 124.881Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M108.072 10.8295H88.7754V13.6448H108.072V10.8295Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7862 15.6882C83.5223 15.6882 84.9298 14.2796 84.9298 12.542C84.9298 10.8044 83.5223 9.39581 81.7862 9.39581C80.05 9.39581 78.6426 10.8044 78.6426 12.542C78.6426 14.2796 80.05 15.6882 81.7862 15.6882Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.078 34.7799H76.23C74.6219 34.7799 73.3184 36.0845 73.3184 37.6939V40.6949C73.3184 42.3043 74.6219 43.6089 76.23 43.6089H115.078C116.686 43.6089 117.99 42.3043 117.99 40.6949V37.6939C117.99 36.0845 116.686 34.7799 115.078 34.7799Z",
    fill: "#24285B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.969 39.5456C111.969 39.5456 110.009 39.5456 109.731 44.0269C109.452 48.5081 109.731 120.649 109.731 126.808C109.731 132.967 100.625 134.099 100.625 134.099H73.3125V44.0269C73.3125 39.2612 76.9549 39.5456 76.9549 39.5456H111.969Z",
    fill: "#0D9F3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.236 46.1282H77.7148V48.7925H88.236V46.1282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 46.1282H96.5469V48.7925H104.736V46.1282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.5769 53.1751H77.7148V55.8395H91.5769V53.1751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 53.1751H96.5469V55.8395H104.736V53.1751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.2858 60.2162H77.7148V62.8806H89.2858V60.2162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 60.2162H96.5469V62.8806H104.736V60.2162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.5769 67.2574H77.7148V69.9218H91.5769V67.2574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 67.2574H96.5469V69.9218H104.736V67.2574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.9774 74.2986H77.7148V76.963H86.9774V74.2986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 74.2986H96.5469V76.963H104.736V74.2986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.7484 81.3455H77.7148V84.0099H92.7484V81.3455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 81.3455H96.5469V84.0099H104.736V81.3455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.2858 88.3867H77.7148V91.051H89.2858V88.3867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 88.3867H96.5469V91.051H104.736V88.3867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.6458 95.4278H77.7148V98.0922H84.6458V95.4278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 95.4278H96.5469V98.0922H104.736V95.4278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.8079 102.469H77.7148V105.133H89.8079V102.469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 102.469H96.5469V105.133H104.736V102.469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.9774 102.318H77.7148V104.982H86.9774V102.318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.7484 109.359H77.7148V112.024H92.7484V109.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 109.359H96.5469V112.024H104.736V109.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.2858 116.406H77.7148V119.07H89.2858V116.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 116.406H96.5469V119.07H104.736V116.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.6458 123.447H77.7148V126.112H84.6458V123.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.736 123.447H96.5469V126.112H104.736V123.447Z",
    fill: "black"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1721 62.2479H47.0613C45.8169 62.2479 44.6234 62.7427 43.7435 63.6234C42.8635 64.504 42.3691 65.6985 42.3691 66.944V134.099H71.2183C71.2183 134.099 78.7583 134.378 80.8811 125.827C83.0039 117.277 83.2011 62.9503 83.2011 62.9503",
    fill: "#0D9F3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M83.1721 62.2479H47.0613C45.8169 62.2479 44.6234 62.7427 43.7435 63.6234C42.8635 64.504 42.3691 65.6985 42.3691 66.944V134.099H71.2183C71.2183 134.099 78.7583 134.378 80.8811 125.827C83.0039 117.277 83.2011 62.9503 83.2011 62.9503",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2012 127.302H28.1426C28.1635 128.675 28.5346 130.02 29.2208 131.21C29.907 132.4 30.8854 133.394 32.0634 134.099H68.5396C68.5396 134.099 64.903 132.625 64.2012 127.302Z",
    fill: "#0D9F3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.466 134.099C101.466 134.099 97.4056 133.675 95.306 131.574C93.2064 129.473 92.6438 127.371 92.6438 120.226V71.0769C92.6438 68.7353 91.7143 66.4896 90.0599 64.8339C88.4055 63.1781 86.1617 62.2479 83.822 62.2479H83.1724C82.4277 62.2479 81.6904 62.3948 81.0025 62.6802C80.3146 62.9655 79.6897 63.3838 79.1634 63.911C78.6372 64.4383 78.2199 65.0642 77.9355 65.7529C77.651 66.4416 77.505 67.1797 77.5058 67.925V119.732C77.5058 133.188 71.6246 134.099 71.2012 134.099H101.466Z",
    fill: "#0D9F3F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.2012 127.302H28.1426C28.1635 128.675 28.5346 130.02 29.2208 131.21C29.907 132.4 30.8854 133.394 32.0634 134.099H68.5396C68.5396 134.099 64.903 132.625 64.2012 127.302Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.466 134.099C101.466 134.099 97.4056 133.675 95.306 131.574C93.2064 129.473 92.6438 127.371 92.6438 120.226V71.0769C92.6438 68.7353 91.7143 66.4896 90.0599 64.8339C88.4055 63.1781 86.1617 62.2479 83.822 62.2479H83.1724C82.4277 62.2479 81.6904 62.3948 81.0025 62.6802C80.3146 62.9655 79.6897 63.3838 79.1634 63.911C78.6372 64.4383 78.2199 65.0642 77.9355 65.7529C77.651 66.4416 77.505 67.1797 77.5058 67.925V119.732C77.5058 133.188 71.6246 134.099 71.2012 134.099H101.466Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.6208 71.1466H46.0996V73.811H56.6208V71.1466Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 71.1466H64.9375V73.811H73.1271V71.1466Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.9616 78.1877H46.0996V80.8521H59.9616V78.1877Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 78.1877H64.9375V80.8521H73.1271V78.1877Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.6706 85.2347H46.0996V87.899H57.6706V85.2347Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 85.2347H64.9375V87.899H73.1271V85.2347Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.9616 92.2758H46.0996V94.9402H59.9616V92.2758Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 92.2758H64.9375V94.9402H73.1271V92.2758Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.3622 99.317H46.0996V101.981H55.3622V99.317Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 99.317H64.9375V101.981H73.1271V99.317Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.6706 106.77H46.0996V109.435H57.6706V106.77Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 106.77H64.9375V109.435H73.1271V106.77Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.0306 113.811H46.0996V116.476H53.0306V113.811Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 113.811H64.9375V116.476H73.1271V113.811Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.1926 120.853H46.0996V123.517H58.1926V120.853Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1271 120.853H64.9375V123.517H73.1271V120.853Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M70.1577 19.7398H60.1934V38.8316H70.1577V19.7398Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.516 17.6385H43.5645V36.7303H68.516V17.6385Z",
    fill: "#E6E6E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M129.028 15.543C128.347 15.2849 127.644 15.0905 126.928 14.9625C125.212 14.6935 123.457 14.8207 121.797 15.3345C120.137 15.8483 118.617 16.7351 117.352 17.9271C116.087 19.1191 115.111 20.5847 114.499 22.212C113.886 23.8393 113.654 25.5851 113.819 27.316C113.984 29.0469 114.543 30.7171 115.452 32.199C116.361 33.6808 117.596 34.9351 119.064 35.8658C120.531 36.7966 122.192 37.3793 123.919 37.5694C125.646 37.7595 127.393 37.5519 129.028 36.9625V15.543Z",
    fill: "black"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M127.084 35.8538C133.379 35.8538 138.481 30.747 138.481 24.4474C138.481 18.1479 133.379 13.0411 127.084 13.0411C120.79 13.0411 115.688 18.1479 115.688 24.4474C115.688 30.747 120.79 35.8538 127.084 35.8538Z",
    fill: "#FFD200"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M127.45 18.7414C127.774 18.7414 127.873 18.8517 127.873 19.1767V19.8617C128.439 19.9227 128.977 20.1363 129.431 20.4799C129.884 20.8234 130.236 21.2839 130.448 21.8121C130.616 22.1488 130.547 22.3287 130.17 22.4971L129.48 22.8105C129.161 22.9614 129.004 22.8918 128.824 22.5551C128.683 22.205 128.432 21.9104 128.108 21.7156C127.785 21.5209 127.407 21.4366 127.032 21.4754C125.837 21.4754 125.292 21.8237 125.292 22.6364C125.319 22.8812 125.431 23.1089 125.608 23.2804C125.784 23.452 126.015 23.5567 126.261 23.5767C126.593 23.65 126.93 23.7023 127.27 23.7335C127.905 23.7624 128.532 23.8836 129.132 24.0934C129.433 24.1923 129.714 24.3457 129.961 24.5461C130.214 24.8059 130.413 25.1139 130.546 25.4519C130.678 25.7898 130.742 26.151 130.732 26.5139C130.732 28.0406 129.706 29.0796 127.902 29.3466V30.078C127.902 30.3973 127.803 30.5134 127.479 30.5134H126.672C126.353 30.5134 126.237 30.3973 126.237 30.078V29.3408C125.609 29.2983 125.008 29.0704 124.51 28.6861C124.011 28.3018 123.637 27.7782 123.436 27.1815C123.326 26.8738 123.436 26.6649 123.761 26.5372L124.445 26.2875C124.793 26.1598 124.95 26.2469 125.106 26.5952C125.251 26.9695 125.514 27.2859 125.856 27.4957C126.197 27.7055 126.598 27.797 126.997 27.7561C128.285 27.7561 128.929 27.3498 128.929 26.5197C128.941 26.3309 128.891 26.1432 128.786 25.9858C128.681 25.8284 128.528 25.71 128.349 25.649C127.902 25.4934 127.435 25.4054 126.962 25.3878C126.319 25.3475 125.685 25.2085 125.083 24.9757C124.591 24.8199 124.167 24.4998 123.882 24.0688C123.597 23.6377 123.468 23.1219 123.517 22.6073C123.517 21.0923 124.468 20.0823 126.261 19.8443V19.1767C126.261 18.8517 126.377 18.7414 126.696 18.7414H127.45Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M129.005 62.2595H112.301V96.2985H129.005V62.2595Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.679 59.3572H116.232V93.3962H145.679V59.3572Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M141.886 63.7571H120.025V71.5239H141.886V63.7571Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M130.251 74.2811H120.025V81.0495H130.251V74.2811Z",
    fill: "#C9C9C9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M141.886 74.2811H131.66V81.0495H141.886V74.2811Z",
    fill: "#C9C9C9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.251 82.8141H120.025V89.5825H130.251V82.8141Z",
    fill: "#C9C9C9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.886 82.8141H131.66V89.5825H141.886V82.8141Z",
    fill: "#C9C9C9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.65 26.4153H48.373V32.162H51.65V26.4153Z",
    fill: "#FFD200"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6813 24.9757H54.4043V32.162H57.6813V24.9757Z",
    fill: "#0D9F3F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7145 22.2068H60.4375V32.162H63.7145V22.2068Z",
    fill: "#24285B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M127.629 127.197C127.629 127.197 122.989 125.926 121.951 121.584C121.951 121.584 129.172 120.121 129.381 127.58L127.629 127.197Z",
    fill: "#0D9F3F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M128.197 126.739C128.197 126.739 124.944 121.584 127.809 116.766C127.809 116.766 133.301 120.249 130.86 126.744L128.197 126.739Z",
    fill: "#0D9F3F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.039 126.739C129.039 126.739 130.779 121.3 135.964 120.266C135.964 120.266 136.939 123.801 132.594 126.756L129.039 126.739Z",
    fill: "#0D9F3F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M125.658 126.617L126.604 133.089L132.554 133.112L133.43 126.651L125.658 126.617Z",
    fill: "#24285B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceApp);
export default __webpack_public_path__ + "static/media/finance_app.8fb2de80e8c633c4cc371fc33e97fb53.svg";
export { ForwardRef as ReactComponent };